const NotFoundPage = () => {
  return (
    <div className="NotFoundPage">
      <h2>The page you are looking for does not exist</h2>
      <a href="/">Click here to view available stations</a>
    </div>
  );
};

export default NotFoundPage;
